module.exports = __webpack_public_path__ + "static/media/instagram.868b0d4b.svg";